import { TreeDataNode } from 'antd'

import { Location } from './types'

export const convertLocationToNode = (location: Location): TreeDataNode => ({
  key: location.id,
  title: location.name,
  children: location.children
    ? convertLocationsToTree(location.children)
    : undefined,
})

export const convertLocationsToTree = (
  locations: Location[]
): TreeDataNode[] => {
  return locations.map(convertLocationToNode)
}

export const findNode = (id: string, nodes: TreeDataNode[]): TreeDataNode => {
  for (const node of nodes) {
    if (node.key === id) return node

    if (node.children) {
      const found = findNode(id, node.children)
      if (found) return found
    }
  }

  return null
}
